import React from 'react';
import PropTypes from 'prop-types';

import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

export function BuildingDescriptionDetails({ details }) {
  const { external, about } = details;
  const siteSizeBoolean = external.siteSize > 0;
  const landSettingsBoolean = external.landSettings > 0;
  const recordedEstateTaxBoolean = (
    about.lastRecordedRealEstatePropertyTaxYear && about.lastRecordedRealEstatePropertyTaxValue
  );
  const taxRateBoolean = !!about.taxRate;
  const availableLandBoolean = external.adjacentAvailableLand > 0.00;
  const landUseBoolean = !!external.adjacentLandUse;

  return (
    <section>
      { (siteSizeBoolean || landSettingsBoolean || recordedEstateTaxBoolean || taxRateBoolean ||
        availableLandBoolean || landUseBoolean) &&
        <ViewerPrimaryColorUserStyle domStyle="color">
          <h4 className="section-title">Site Description</h4>
        </ViewerPrimaryColorUserStyle>
      }
      <div className="section-body">
        <ul>
          {
            siteSizeBoolean &&
            <li><strong>Site Size: </strong> {external.siteSize} ac.</li>
          }
          {
            landSettingsBoolean &&
            <li><strong>Land Setting: </strong> {external.landSettings}</li>
          }
          {
            (recordedEstateTaxBoolean &&
            parseFloat(about.lastRecordedRealEstatePropertyTaxValue).toFixed(2) !== 'NaN') &&
            <li>
              <strong>Last Property Taxes: </strong>
              {about.lastRecordedRealEstatePropertyTaxYear} - $
              {parseFloat(about.lastRecordedRealEstatePropertyTaxValue).toFixed(2)}
            </li>
          }
          {
            taxRateBoolean &&
            <li><strong>Tax Rate: </strong> {about.taxRate}</li>
          }
          {
            availableLandBoolean &&
            <li>
              <strong>Adjacent Available Land: </strong> {external.adjacentAvailableLand} ac.
            </li>
          }
          {
            landUseBoolean &&
            <li><strong>Adjacent Land Use: </strong>{external.adjacentLandUse}</li>
          }
        </ul>
      </div>
    </section>
  );
}

BuildingDescriptionDetails.propTypes = {
  details: PropTypes.object.isRequired,
};

export default BuildingDescriptionDetails;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailAdditional/AdditionalDetails/BuildingDescriptionDetails.js